import {useCallback, useEffect, useRef} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {usePatientContext} from '../styled-component/information/StyleDetailInformationWrapper'

const WatchLine = ({
    showWatchActivationForm = () => {},
    isDrawable = false,
    isAddHoverEffect = false,
}) => {
    const {currentViewedUser} = usePatientContext()
    const {translateKeys, translateCommons} = TranslateUtils()

    const toRemoveListenerNodes = useRef([])
    const lineRef = useRef([])

    //#region Hover Effect and Calculation
    const addHoverEffect = useCallback(
        (elementStart, elementEnd, deviceAssigned) => {
            if (!isAddHoverEffect) {
                return
            }
            if (!!elementStart && elementStart?.id) {
                const otherLabels = document.getElementsByClassName(
                    'samsung-watch-label',
                )
                const startElementWrapper = document.getElementById(
                    elementStart?.id + '-wrapper',
                )
                if (!!startElementWrapper) {
                    startElementWrapper.addEventListener('mouseenter', () => {
                        if (!!otherLabels && otherLabels?.length > 0) {
                            for (let labelElement of otherLabels) {
                                if (
                                    !!labelElement &&
                                    labelElement?.id === startElementWrapper?.id
                                ) {
                                    labelElement.style.opacity = 1
                                    labelElement.style.boxShadow = '#f9f9f9'
                                    continue
                                } else {
                                    labelElement.style.opacity = 0.2
                                }
                            }
                        }

                        removeLinesOnly()

                        if (
                            (!!deviceAssigned ||
                                elementStart?.id === 'watch-assigned-label') &&
                            !!elementStart &&
                            !!elementEnd?.id
                        ) {
                            drawLine(
                                elementStart,
                                elementEnd,
                                null,
                                elementStart?.id === 'watch-assigned-label' &&
                                    !deviceAssigned
                                    ? window.LeaderLine.pathLabel(
                                          translateCommons('Assign a watch'),
                                      )
                                    : null,
                            )
                        }
                    })
                    startElementWrapper.addEventListener('mouseleave', () => {
                        if (!!otherLabels && otherLabels?.length > 0) {
                            for (let labelElement of otherLabels) {
                                labelElement.style.opacity = 1
                            }
                        }

                        removeLinesOnly()

                        const storageDeviceAssigned = localStorage.getItem(
                            'deviceAssigned',
                        )
                            ? JSON.parse(localStorage.getItem('deviceAssigned'))
                            : null
                        if (
                            elementStart?.id === 'watch-assigned-label' &&
                            !storageDeviceAssigned
                        ) {
                            drawLine(
                                elementStart,
                                elementEnd,
                                null,
                                !storageDeviceAssigned
                                    ? window.LeaderLine.pathLabel(
                                          translateCommons('Assign a watch'),
                                      )
                                    : null,
                            )
                        }
                    })
                    toRemoveListenerNodes.current.push(startElementWrapper)
                }
            }
        },
        [isAddHoverEffect],
    )

    const calculateStrokeDashoffset = percentage => {
        const totalLength = 565.48

        if (!percentage || percentage < 0 || percentage > 100) {
            return totalLength
        }

        return totalLength * (1 - percentage / 100)
    }
    //#endregion

    //#region Points to Watch Interface
    const pointToAssignmentStatus = isActive => {
        let start = null
        let end = null

        const logoutWrapper = document.getElementById('logout-wrapper')
        const logoutBtn = document.getElementById('logout-button')

        const loginWrapper = document.getElementById('login-wrapper')
        const loginBtn = document.getElementById('login-button')

        const assignmentWrapper = document.getElementById('assignment-wrapper')
        const assignedElement = document.getElementById('assigned-status')
        const unassignedElement = document.getElementById('unassigned-status')

        // logout buttons
        if (!!logoutWrapper) {
            if (!isActive) {
                logoutWrapper.classList.add('hidden')
            } else {
                logoutWrapper.classList.remove('hidden')
            }

            loginWrapper.addEventListener('click', () => {
                showWatchActivationForm()
            })

            if (!!logoutBtn) {
                if (!isActive) {
                    logoutBtn.classList.add('hidden')
                } else {
                    logoutBtn.classList.remove('hidden')
                }

                logoutBtn.addEventListener('click', () => {
                    showWatchActivationForm()
                })
            }
        }

        // login buttons
        if (!!loginWrapper) {
            if (!!isActive) {
                loginWrapper.classList.add('hidden')
            } else {
                loginWrapper.classList.remove('hidden')
                end = loginWrapper
            }

            logoutWrapper.addEventListener('click', () => {
                showWatchActivationForm()
            })

            if (!!loginBtn) {
                loginBtn.classList.remove('hidden')

                loginBtn.addEventListener('click', () => {
                    showWatchActivationForm()
                })
            }
        }

        if (!!assignmentWrapper) {
            if (!isActive) {
                assignmentWrapper.classList.add('hidden')
            } else {
                assignmentWrapper.classList.remove('hidden')

                if (!!assignedElement) {
                    assignedElement.classList.remove('hidden')
                    end = assignedElement
                }
            }
        }

        start = document.getElementById('watch-assigned-label')

        if (!!start && !!end) {
            addHoverEffect(start, end, isActive)

            if (!isActive) {
                drawLine(
                    start,
                    end,
                    null,
                    !isActive
                        ? window.LeaderLine.pathLabel(
                              translateCommons('Assign a watch'),
                          )
                        : null,
                )
            }
        }
    }

    const pointToBatteryStatus = (isActive, batteryLevel, isCharging) => {
        let startBatteryLevel = null
        let endBatteryLevel = null

        let startBatteryChargeState = null
        let endBatteryChargeState = null

        const batteryWrapper = document.getElementById('battery-wrapper')
        const batteryElement = document.getElementById('battery-level')
        const batteryChargingElement =
            document.getElementById('battery-charging')
        const batteryInUseElement = document.getElementById('battery-in-use')
        const batteryCircleOffsetElement = document.getElementById(
            'battery-circle-offset',
        )

        if (!isActive) {
            if (!!batteryWrapper) batteryWrapper.classList.add('hidden')
            if (!!batteryChargingElement)
                batteryChargingElement.classList.add('hidden')
            if (!!batteryInUseElement)
                batteryInUseElement.classList.add('hidden')
        } else {
            if (batteryWrapper) batteryWrapper.classList.remove('hidden')
            if (isCharging) {
                if (!!batteryChargingElement)
                    batteryChargingElement.classList.remove('hidden')
                if (!!batteryInUseElement)
                    batteryInUseElement.classList.add('hidden')
                endBatteryChargeState = batteryChargingElement
            } else {
                if (!!batteryInUseElement)
                    batteryInUseElement.classList.remove('hidden')
                if (!!batteryChargingElement)
                    batteryChargingElement.classList.add('hidden')
                endBatteryChargeState = batteryInUseElement
            }

            if (!!batteryElement) {
                let batteryLifeNumber = 0
                try {
                    batteryLifeNumber = parseInt(batteryLevel)
                } catch (error) {}

                batteryElement.textContent = batteryLevel
                    ? `${batteryLevel}%`
                    : '-'

                if (batteryLifeNumber === 100) {
                    batteryElement.setAttribute('x', '35px')
                } else if (batteryLifeNumber >= 10 && batteryLifeNumber < 100) {
                    batteryElement.setAttribute('x', '55px')
                } else if (batteryLifeNumber < 10) {
                    batteryElement.setAttribute('x', '75px')
                }

                endBatteryLevel = batteryElement

                const circleOffset =
                    calculateStrokeDashoffset(batteryLifeNumber)
                if (!!batteryCircleOffsetElement) {
                    batteryCircleOffsetElement.style.strokeDashoffset =
                        circleOffset
                }
            }
        }

        startBatteryLevel = document.getElementById('watch-battery-level-label')
        if (!!startBatteryLevel && !!endBatteryLevel) {
            if (!!isActive) {
                addHoverEffect(startBatteryLevel, endBatteryLevel, isActive)
            }
        }

        startBatteryChargeState = document.getElementById(
            'watch-charging-label',
        )

        if (!!startBatteryChargeState && !!endBatteryChargeState) {
            if (!!isActive) {
                addHoverEffect(
                    startBatteryChargeState,
                    endBatteryChargeState,
                    isActive,
                )
            }
        }
    }

    const pointToWatchInteractionMode = (isActive, isInteraction) => {
        let start = null
        let end = null

        const interactionWrapper = document.getElementById(
            'interaction-wrapper',
        )
        const interactionElement = document.getElementById('interaction-on')
        const noInteractionElement = document.getElementById('interaction-off')

        if (!isActive) {
            if (!!interactionWrapper) interactionWrapper.classList.add('hidden')
            if (!!interactionElement) interactionElement.classList.add('hidden')
            if (!!noInteractionElement)
                noInteractionElement.classList.add('hidden')
        } else {
            if (interactionWrapper)
                interactionWrapper.classList.remove('hidden')
            if (isInteraction) {
                if (!!interactionElement)
                    interactionElement.classList.remove('hidden')
                if (!!noInteractionElement)
                    noInteractionElement.classList.add('hidden')
                end = interactionElement
            } else {
                if (!!noInteractionElement)
                    noInteractionElement.classList.remove('hidden')
                if (interactionElement)
                    interactionElement.classList.add('hidden')
                end = noInteractionElement
            }
        }

        start = document.getElementById('watch-interaction-label')

        if (!!start && !!end) {
            addHoverEffect(start, end, isActive)
        }
    }

    const pointToOnWristStatus = (isActive, isWorn) => {
        let start = null
        let end = null

        const onWristWrapper = document.getElementById('on-wrist-wrapper')
        const onWristElement = document.getElementById('being-worn')
        const takeOffElement = document.getElementById('not-being-worn')

        if (!isActive) {
            if (!!onWristWrapper) onWristWrapper.classList.add('hidden')
            if (!!onWristElement) onWristElement.classList.add('hidden')
            if (!!takeOffElement) takeOffElement.classList.add('hidden')
        } else {
            if (!!onWristWrapper) onWristWrapper.classList.remove('hidden')
            if (!!isWorn) {
                if (!!onWristElement) onWristElement.classList.remove('hidden')
                if (!!takeOffElement) takeOffElement.classList.add('hidden')
                end = onWristElement
            } else {
                if (!!takeOffElement) takeOffElement.classList.remove('hidden')
                if (!!onWristElement) onWristElement.classList.add('hidden')
                end = takeOffElement
            }
        }

        start = document.getElementById('watch-worn-status-label')

        if (!!start && !!end) {
            addHoverEffect(start, end, isActive)
        }
    }

    const pointToSpatchIntegration = (
        isActive,
        spatchDeviceName,
        deviceAssigned,
    ) => {
        let start = null
        let end = null

        const spatchWrapper = document.getElementById('spatch-wrapper')
        const spatchElement = document.getElementById('spatch-connected')
        const noSpatchElement = document.getElementById('spatch-disconnected')

        if (!isActive) {
            if (!!spatchWrapper) spatchWrapper.classList.add('hidden')
            if (!!spatchElement) spatchElement.classList.add('hidden')
            if (!!noSpatchElement) noSpatchElement.classList.add('hidden')
        } else {
            if (!!spatchWrapper) spatchWrapper.classList.remove('hidden')
            if (!!spatchDeviceName) {
                if (!!spatchElement) spatchElement.classList.remove('hidden')
                if (!!noSpatchElement) noSpatchElement.classList.add('hidden')
                end = spatchElement
            } else {
                if (!!noSpatchElement)
                    noSpatchElement.classList.remove('hidden')
                if (!!spatchElement) spatchElement.classList.add('hidden')
                end = noSpatchElement
            }
        }

        start = document.getElementById('watch-spatch-integration-label')

        if (!!start && !!end) {
            addHoverEffect(start, end, isActive)
        }
    }
    //#endregion

    //#region Draw Line
    const drawAll = ({
        deviceAssigned,
        batteryLife,
        charging,
        watchInteraction,
        beingWorn,
        spatchDeviceName,
    }) => {
        try {
            if (!!currentViewedUser && !!currentViewedUser?.id) {
                pointToAssignmentStatus(deviceAssigned)

                pointToBatteryStatus(deviceAssigned, batteryLife, charging)
                pointToWatchInteractionMode(deviceAssigned, watchInteraction)
                pointToOnWristStatus(deviceAssigned, beingWorn)
                pointToSpatchIntegration(deviceAssigned, spatchDeviceName)
            }
        } catch (err) {}
    }

    const drawLine = useCallback(
        (start, end, startLabel, endLabel) => {
            if (!isDrawable) {
                return
            }

            if (!!start && !!end) {
                const startElement = document.getElementById(start?.id)
                const endElement = document.getElementById(end?.id)

                const storageDeviceAssigned = localStorage.getItem(
                    'deviceAssigned',
                )
                    ? JSON.parse(localStorage.getItem('deviceAssigned'))
                    : null

                if (
                    start?.id === 'watch-assigned-label' ||
                    !!storageDeviceAssigned
                ) {
                    if (!!startElement && !!endElement) {
                        try {
                            const line = new window.LeaderLine(
                                startElement,
                                endElement,
                                {
                                    size: 3,
                                    path: 'disc',
                                    color: 'black',
                                    startPlug: 'disc',
                                    endPlug: 'arrow3',
                                    startPlugColor: 'darkcyan',
                                    endPlugColor: 'lightgray',
                                    gradient: true,
                                    animated: true,
                                    startLabel: startLabel ? startLabel : null,
                                    endLabel: endLabel ? endLabel : null,
                                },
                            )
                            if (!!line) {
                                lineRef.current.push(line)
                            }
                        } catch (error) {}
                    }
                }
            }
        },
        [isDrawable],
    )

    const removeLinesOnly = () => {
        const lineChartWrapper =
            window.document.getElementById('leader-line-defs')
        if (!!lineChartWrapper) {
            try {
                lineChartWrapper?.remove()
            } catch (error) {}
        }

        if (toRemoveListenerNodes.current?.length > 0) {
            toRemoveListenerNodes.current.forEach(item => {
                try {
                    item.removeEventListener('mouseenter', () => {}, true)
                    item.removeEventListener('mouseleave', () => {}, true)
                    item.removeEventListener('pointerenter', () => {}, true)
                    item.removeEventListener('pointerleave', () => {}, true)
                } catch (error) {}
            })
        }

        if (lineRef.current?.length > 0) {
            lineRef.current.forEach(item => {
                try {
                    item?.remove()
                } catch (error) {}
            })
        }
    }

    const timeoutRef = useRef(null)

    useEffect(() => {
        if (!currentViewedUser || !currentViewedUser?.id) {
            return
        }

        localStorage.setItem(
            'deviceAssigned',
            currentViewedUser?.deviceAssigned,
        )

        removeLinesOnly()

        timeoutRef.current = setTimeout(() => {
            drawAll({
                deviceAssigned: currentViewedUser?.deviceAssigned,
                batteryLife: currentViewedUser?.batteryLife,
                charging: currentViewedUser?.charging,
                watchInteraction:
                    currentViewedUser?.accessConfig?.watchInteraction || false,
                beingWorn: currentViewedUser?.beingWorn || false,
                spatchDeviceName: currentViewedUser?.spatchDeviceName,
            })
        }, 50)

        return () => {
            clearTimeout(timeoutRef.current)

            removeLinesOnly()

            toRemoveListenerNodes.current = []
            lineRef.current = []
        }
    }, [currentViewedUser, isDrawable, isAddHoverEffect])
    //#endregion

    return null
}

export default WatchLine
